export const AFFILIATE_URL = "https://fd4878zbjcxt8x2ps9oz5jxqb2.hop.clickbank.net";

/**
 * Generate affiliate URL with tracking reference
 * @param ref - Unique tracking reference for analytics (e.g., "hero-primary", "nav-desktop")
 * @returns Full affiliate URL with ref parameter
 */
export const getAffiliateUrl = (ref: string): string => {
  return `${AFFILIATE_URL}?ref=${ref}`;
};
